import { CSSProperties, memo, useMemo } from 'react';
import { GridCell } from '../../../../../../../../../api/generated/data-contracts';
import { useGridContext } from '../../../../../../../_grid/contexts/gridContext';
import { useFixedCellValue } from '../../../../../../../_grid/hooks/useFixedCellValue';
import { CELL_HEIGHT, CELL_WIDTH } from '../../../../CONSTANTS';
import { Cell } from '../../../Cell/Cell';
import { ColumnRowProps } from '../../ColumnRowProps';

export const ContractColumnRow = memo(({ columnRow, columnIndex, rowId }: ColumnRowProps) => {
    const render = useMemo(() => {
        return columnRow.cells.map((cell, i) => {
            if (i === 1) {
                return <Cell key={cell.id} cell={cell} cellIndex={i} columnIndex={columnIndex} rowId={rowId} />;
            }
            return <ContractRequestCell key={cell.id} cell={cell} />;
        });
    }, [columnIndex, columnRow.cells, rowId]);
    return <ColumnGridContainer>{render}</ColumnGridContainer>;
});

const ColumnGridContainer = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
    const style = useMemo(() => {
        return {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            padding: '0px 10px',
            gap: 10,
            alignItems: 'center',
            height: '100%',
        } as CSSProperties;
    }, []);
    return <div style={style} {...props} />;
};

const ContractRequestCell = ({ cell }: { cell: GridCell }) => {
    const { useGridCellValue } = useGridContext();
    const storeValue = useGridCellValue(cell);
    const value = useFixedCellValue(storeValue);

    return <div style={contractRequestCellStyles} className='Request'>{value}</div>;
};

const contractRequestCellStyles: CSSProperties = {
    paddingRight: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'end',
    height: CELL_HEIGHT,
    width: CELL_WIDTH,
};
